<template>
  <div class="content">
    <el-row type="flex" justify="start">
      <el-col :span="12">
        <el-form label-position="left" :model="form" :rules="rules" ref="form">
          <h3>美金积分兑换比率</h3>
          <el-form-item label="1:" prop="money_point_exchange_rate">
            <el-row type="flex">
              <el-input
                v-model="form.money_point_exchange_rate"
                type="number"
                placeholder="请输入正整数"
              >
              </el-input>
            </el-row>
          </el-form-item>
          <h3>中文-优惠码兑换操作指引</h3>
          <el-form-item
            label="优惠码兑换操作指引"
            prop="doc.lang_list[1].content"
          >
            <tinymce
              :height="400"
              v-model="form.doc.lang_list[1].content"
              :value="form.doc.lang_list[1].content"
              ref="tinymce"
            />
          </el-form-item>
          <!-- <h3>繁体-优惠码兑换操作指引</h3>
          <el-form-item
            label="优惠码兑换操作指引"
            prop="doc.lang_list[2].content"
          >
            <tinymce
              :height="400"
              v-model="form.doc.lang_list[2].content"
              :value="form.doc.lang_list[2].content"
              ref="tinymce"
            />
          </el-form-item> -->
          <h3>英文-优惠码兑换操作指引</h3>
          <el-form-item
            label="优惠码兑换操作指引"
            prop="doc.lang_list[0].content"
          >
            <tinymce
              :height="400"
              v-model="form.doc.lang_list[0].content"
              :value="form.doc.lang_list[0].content"
              ref="tinymce"
            />
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button
                type="primary"
                @click="configStore"
                :loading="btnLoading"
                >提交</el-button
              >
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import Tinymce from '@/components/Tinymce'
export default {
  components: { Tinymce },
  data() {
    return {
      grade: '',
      gradearray: [],
      btnLoading: false,
      rules: {
        'doc.lang_list[0].content': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'doc.lang_list[1].content': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'doc.lang_list[2].content': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        money_point_exchange_rate: [
          {
            required: true,
            message: '请输入兑换比率',
            trigger: 'change',
          },
        ],
      },
      form: {
        money_point_exchange_rate: '',
        doc: {
          lang_list: [
            {
              lang: 'en_US',
              content: '',
            },
            {
              lang: 'zh-CN',
              content: '',
            },
            // {
            //   lang: 'zh-TW',
            //   content: '',
            // },
          ],
        },
      },
    }
  },
  mounted() {
    this.configs()
  },
  methods: {
    configs() {
      request({
        url: '/api/backend/coupon/configs',
        method: 'get',
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
        }
      })
    },
    configStore() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/coupon/configStore',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
